import { render, staticRenderFns } from "./BsStatistics.vue?vue&type=template&id=106fa973&scoped=true&"
import script from "./BsStatistics.vue?vue&type=script&lang=js&"
export * from "./BsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./BsStatistics.vue?vue&type=style&index=0&id=106fa973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106fa973",
  null
  
)

export default component.exports